<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" class="d-flex justify-center" v-if="tiles.length == 0">
        <p class="pa-4 text-subtitle-2">
          表示設定されているタイルがありません。設定画面からタイルを追加してください
        </p>
      </v-col>

      <v-col cols="12" md="6" lg="4" xl="3" v-for="tile in tiles" v-bind:key="tile.key">
        <latest-tile
          :loading="tile.isLoading"

          :name="tile.name"

          :alt-values="tile.altValues"

          :unit="tile.unit"

          :alarms="tile.alarms"

          :intervalMinutes="tile.intervalMinutes"

          :time="tile.time"
          :value="tile.value"
        ></latest-tile>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';

import axios from 'axios';

import config from '@/config.js';

import LatestTile from '../components/LatestTile.vue';

export default {
  name: 'TileView',
  components: {
    LatestTile
  },

  setup() {

    const tiles = ref([]);

    const moduleIDSet = new Set();


    let intervalID;

    onMounted(() => {

      const tilesSetting = window.localStorage.getItem('tiles-setting');
      if (tilesSetting != null) {
        tiles.value = JSON.parse(tilesSetting);
      }

      tiles.value.forEach((tile) => {
        moduleIDSet.add(tile.moduleID);
      });

      setChannelsInfo();

      reloadTiles();

      // TBD 最新値データ取得の周期設定
      intervalID = setInterval(reloadTiles, 60000);

    });

    onBeforeUnmount(() => {
      clearInterval(intervalID);
    });

    const reloadTiles = () => {

      tiles.value.forEach((tile) => {
        tile.isLoading = true;
      });

      moduleIDSet.forEach((id) => {

        axios.get(
          config.API_URL +
          `/modules/${ id }/latest`,
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
        ).then((response) => {

          if (response.data.time != null) {

            tiles.value.forEach((tile) => {
              if (tile.moduleID === response.data.moduleID) {

                if (tile.ch in response.data) {

                  tile.time = response.data.time;

                  const val = response.data[tile.ch].value;
                  tile.value = val.toString();

                  tile.isLoading = false;

                } else {
                  // TBD まだ一度もデータ送信されていない場合
                }

              }
            });

          } else {
            // TBD まだ一度もデータ送信されていない場合
          }

        }).catch((/* error */) => {
          // TBD リフレッシュトークンの利用を検討
          window.sessionStorage.clear();
          window.sessionStorage.setItem('access-token-expired', 'true');

          window.location.reload();
        });

      });

    };

    const setChannelsInfo = () => {

      moduleIDSet.forEach((id) => {

        axios.get(
          config.API_URL +
          `/modules/${ id }`,
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
        ).then((response) => {

          tiles.value.forEach((tile) => {
            if (tile.moduleID === response.data.moduleID) {

              if (tile.ch in response.data.channels) {
                tile.name = response.data.channels[tile.ch].name;


                tile.altValues = response.data.channels[tile.ch].altValue;

                if (tile.ch.startsWith('do')) {
                  tile.altValues = {
                    0: response.data.channels[tile.ch].lowMeaning,
                    1: response.data.channels[tile.ch].highMeaning
                  };
                }


                tile.unit = response.data.channels[tile.ch].unit;

                tile.alarms = response.data.channels[tile.ch].alarms;

                tile.intervalMinutes = response.data.missingDataCriteria.intervalMinutes;
              }

            }
          });

        }).catch((/* error */) => {
          // TBD リフレッシュトークンの利用を検討
          window.sessionStorage.clear();
          window.sessionStorage.setItem('access-token-expired', 'true');

          window.location.reload();
        });

      });

    };

    return {
      tiles
    }
  }
}
</script>
